import { useNavigate } from "react-router-dom";
import KogModalComponent from "@/main/components/modal/ModalComponent";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { getTranslateByKey } from "@/main/services/utils";

function MessagePendingAdmin() {
	const navigate = useNavigate();

	function handleActionConfirm() {
		navigate(RoutesConstants.orderSearchOrder);
	}

	return (
		<KogModalComponent
			open
			content={getTranslateByKey("information.prequotePendingAdmin")}
			disabledCloseIcon
			handleClose={() => {}}
			hasActionCancel={false}
			hasActionConfirm={true}
			labelActionConfirm="Ok"
			onClickActionConfirm={handleActionConfirm}
			title=""
		/>
	);
}

export default MessagePendingAdmin;
